import { useMemo } from 'react';
import { HEADERS } from './constants';
import { adaptHeaders } from '../../utils/table-helpers';

const NO_DATA_FILTER_OPTIONS = {};
const NO_FLAGS = {};

const useHeaders = ({
  usePreferencesForRanking,
  preferenceOptions,
  dataFilterOptions = NO_DATA_FILTER_OPTIONS,
  flags = NO_FLAGS,
}) => {
  return useMemo(() => {
    const headers = HEADERS(usePreferencesForRanking, preferenceOptions).map(
      (header) => ({
        ...header,
        filterOptions: header.filterOptions ?? dataFilterOptions[header.id],
      }),
    );

    // Drops filter options gated off by a flag, e.g. Leslie Needs Help.
    adaptHeaders(headers, { flags });

    return headers;
  }, [usePreferencesForRanking, preferenceOptions, dataFilterOptions, flags]);
};

export default useHeaders;
